/**
 * 搜索框容器
 * @author VenDream
 * @since 17/11/29
 */

import { connect } from 'react-redux';
import SearchBox from 'components/searchbox';
import * as search from 'actions/search';

const { getMainFigure, setSearchKeywords, getSearchHotwords } = search;

const mapStateToProps = state => {
  const { search, storeTabs } = state;
  const { activeIndex, tabs } = storeTabs;
  const tabIndex = tabs.findIndex(n => n.index === activeIndex);
  const category = tabs[tabIndex === -1 ? 0 : tabIndex].name;

  return { category, ...search };
};

const mapDispatchToProps = dispatch => ({
  getMainFigure: () => dispatch(getMainFigure()),
  setSearchKeywords: keywords => dispatch(setSearchKeywords(keywords)),
  getSearchHotwords: () => dispatch(getSearchHotwords()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBox);
